import React from 'react';
import PackageBookings from './PackageBookings';
import RentalBookings from './RentalBookings';
import FlightBookings from './FlightBookings';
import GroupTripBookings from './GroupTripBookings';
import SharedRentalBookings from './SharedRentalBookings';
import { Tab } from 'semantic-ui-react';
import './Bookings.css';

const panes = [
	{ menuItem: 'Flights', render: () => <Tab.Pane><FlightBookings /></Tab.Pane> },
	{ menuItem: 'Group Trips', render: () => <Tab.Pane><GroupTripBookings /></Tab.Pane> },
	{ menuItem: 'Shared Intercity Rentals', render: () => <Tab.Pane><SharedRentalBookings /></Tab.Pane> },
	{ menuItem: 'Private Tours', render: () => <Tab.Pane><PackageBookings /></Tab.Pane> },
	{ menuItem: 'Car Rentals', render: () => <Tab.Pane><RentalBookings /></Tab.Pane> }
];

export default function Bookings() {
	return (
		<div className='booking-list container'>
			<h3 className='title'>Bookings</h3>
			<div className='bookings-content'>
				<Tab 
					menu={{ 
						secondary: true, 
						pointing: true,
						className: 'bookings-tabs'
					}} 
					panes={panes} 
				/>
			</div>
		</div>
	);
}
